export default __webpack_public_path__ + "3e32c20ff28591ca21f587ca015a6dd2.png";